import { render, staticRenderFns } from "./StoreDialog.vue?vue&type=template&id=53845bc3&scoped=true"
import script from "./StoreDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StoreDialog.vue?vue&type=style&index=0&id=53845bc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53845bc3",
  null
  
)

export default component.exports